import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { postRequest, getRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const getAuthHeaders = () => {
  const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
  return { headers: { Authorization: `Bearer ${token}` } };
};

const AddDoctor = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [formData, setFormData] = useState({
    department_id: '',
    type: 'opd',
    name: '',
    education: '',
    number: '',
    image: null,
    status: 'active',
  });

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const res = await getRequest('departments?limit=500');
        if (res?.data?.success) {
          setDepartments(res.data.data || []);
        } else {
          toast.error(res?.data?.message || 'Failed to load departments');
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Error fetching departments');
      }
    };
    fetchDepartments();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (e.target.type === 'file') {
      setFormData((prev) => ({
        ...prev,
        [name]: files && files.length > 0 ? files[0] : null,
      }));
      return;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === 'type' ? { department_id: '' } : {}),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.department_id) {
      toast.error('Department is required');
      return;
    }
    if (!formData.name.trim()) {
      toast.error('Doctor name is required');
      return;
    }

    setLoading(true);

    const payload = new FormData();
    payload.append('department_id', formData.department_id);
    payload.append('type', formData.type);
    payload.append('name', formData.name.trim());
    payload.append('education', formData.education.trim());
    payload.append('number', formData.number.trim());
    payload.append('status', formData.status);
    if (formData.image) {
      payload.append('image', formData.image);
    }

    try {
      const response = await postRequest('doctors', payload, getAuthHeaders());

      if (response?.data?.success) {
        toast.success('Doctor created successfully');
        navigate('/doctors');
      } else {
        toast.error(response?.data?.message || 'Failed to create doctor');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to create doctor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="font-weight-bold">Add Doctor</h4>
      </div>

      <form onSubmit={handleSubmit} className="form-style">
        <div className="row mx-4 mt-5">
          <div className="col-md-6 mt-2">
            <label htmlFor="type">Type</label>
            <select
              id="type"
              name="type"
              className="form-control"
              value={formData.type}
              onChange={handleChange}
            >
              <option value="opd">OPD</option>
              <option value="ipd">IPD</option>
            </select>
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="department_id">Department *</label>
            <select
              id="department_id"
              name="department_id"
              className="form-control"
              value={formData.department_id}
              onChange={handleChange}
              required
            >
              <option value="">Select Department</option>
              {departments
                .filter((dept) => (dept.type || 'opd') === formData.type)
                .map((dept) => (
                  <option key={dept.id} value={dept.id}>
                    {dept.heading}
                  </option>
                ))}
            </select>
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="name">Doctor Name *</label>
            <input
              id="name"
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="education">Education (optional)</label>
            <input
              id="education"
              name="education"
              className="form-control"
              value={formData.education}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="number">Number (optional)</label>
            <input
              id="number"
              name="number"
              className="form-control"
              value={formData.number}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="image">Image (optional)</label>
            <input
              id="image"
              name="image"
              type="file"
              className="form-control-file"
              accept=".png,.jpg,.jpeg,.webp,.gif,.bmp,.svg,.avif,.tiff,.ico,.jfif,.pjpeg,.pjp,image/png,image/jpeg,image/jpg,image/webp,image/gif,image/bmp,image/svg+xml,image/avif,image/tiff,image/x-icon,image/jfif,image/*"
              onChange={handleChange}
            />
            {formData.image && (
              <small className="text-muted d-block mt-1">Selected: {formData.image.name}</small>
            )}
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="status">Status</label>
            <select
              id="status"
              name="status"
              className="form-control"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div className="mt-5 text-right mx-4">
          <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
            {loading ? 'Creating...' : 'Create Doctor'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddDoctor;
